import React, { useState,useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AjouteReservationRequest } from '../Api/FinalReservationApi';
import Loader from "../components/Loader";
import { toast } from 'react-toastify';
import '../Css/finalReservation.css';
import db from '../db';

const FinalReservation = () => {

    const [nom, setNom] = useState("");
    const [prenom, setPrenom] = useState("");
    const [email, setEmail] = useState("");
    const [telephone, setTelephone] = useState("");
    const [demande, setDemande] = useState("");
    const [loading, setLoading] = useState(false);


    let location = useLocation();
    let navigate = useNavigate();
    const { state } = useLocation();
    const { idRestaurant } = state;

  
    const offre = useSelector((state) => state.offre);
    const reservation = useSelector((state) => state.reservation);
    const client = useSelector((state) => state.client);

    const [test,setTest] = useState([]);




    useEffect(() => {
        const fetchAndSetData = async()=> {
        try {
          const donner = await db.monTableau.toArray();
          if (donner.length > 0) {
            setTest(donner.find((el) => el.id === parseInt(idRestaurant)));
            console.log("Donner dans dexi=>",donner);
          }
        } catch (error) {
          console.error('Erreur lors de la récupération des données depuis Dexie :', error);
        }
      };
      fetchAndSetData();
      }, [idRestaurant]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        if (offre.length !== 0) {
            const data = {
                nom: nom, prenom: prenom, email: email, telephone: telephone,
                demandeSpecifique: demande, date: reservation.date, heure: reservation.heure, nombrePersonne: reservation.personne,
                idClient: client.id, idRestaurant: idRestaurant, promotion: offre.libelle
            };
            AjouteReservationRequest(data).then(function (response) {
                console.log(response);
                if (response.data.title === "success") {
                    toast.success(response.data.message);
                    navigate('/confirmation', { state: { idRestaurant: response.data.donner.idRestaurant, idReservation: response.data.donner.idReservation } });
                }
            }).catch(function (error) {
                console.log(error);
                if (error) {
                    toast.error(error.response.data?.message);
                }
            }).finally(function () {
                setLoading(false);
                setNom("");
                setPrenom("");
                setEmail("");
                setTelephone("");
                setDemande("");
            });
        } else {
            const data = {
                nom: nom, prenom: prenom, email: email, telephone: telephone,
                demandeSpecifique: demande, date: reservation.date, heure: reservation.heure, nombrePersonne: reservation.personne,
                idClient: client.id, idRestaurant: idRestaurant
            };
            AjouteReservationRequest(data).then(function (response) {
                console.log(response);
                if (response.data.title === "success") {
                    toast.success(response.data.message);
                    navigate('/confirmation', { state: { idRestaurant: response.data.donner.idRestaurant, idReservation: response.data.donner.idReservation } });
                }
            }).catch(function (error) {
                console.log(error);
                if (error) {
                    toast.error(error.response.data?.message);
                }
            }).finally(function () {
                setLoading(false);
                setNom("");
                setPrenom("");
                setEmail("");
                setTelephone("");
                setDemande("");
            });
        }


    }

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div>
            <Helmet>
                <title>Finaliser réservation</title>
                <meta name='description' content='Finaliser réservation' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='finaliser'>
                {loading && <Loader />}
                <div className='finaliser_content'>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3'>
                            <div className='description_astuces'>
                                <div className='astuces_resto'>
                                    <div className='astuces_apropos'>
                                        <div className='astuces_photo'>
                                            <img src={test?.photos? test?.photos[0]?.basePhoto:""} alt="avatar restaurant" />
                                        </div>
                                        <div className='astuces_adresse'>
                                            <div className='d-flex justify-content-center flex_titre'>
                                                <span className='nom_resto'>{test.nomRestaurant}</span>
                                            </div>
                                            <div className='d-flex justify-content-center flex_titre'>
                                                <span className='astuces_adresse'>{test.adresse}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='astuces_offre'>
                                    <div className='d-flex justify-content-center'>
                                        <span className='astuces_offreTitre'>Rappel type d’offre sélectionnée</span>
                                    </div>
                                    {
                                        offre.length !== 0 ? <div className='astuces_offreContent'>
                                            <span className='astuces_promo'><i className='fa fa-bullhorn'></i>{offre.libelle}</span>
                                            <div className='astuces_offreCondition'>
                                                <span>Hors menus, hors formules</span>
                                                <ul>
                                                    {offre.horsBoisson === true ?
                                                        <li>Hors boisson</li>
                                                        : ''}

                                                    {offre.pourTout === true ?
                                                        <li>Pour toute commande d’Entrée+Plat ou Plat+Dessert minimum par personne</li>
                                                        : ''}

                                                </ul>
                                            </div>
                                        </div> :
                                            <div className='astuces_offreContent'>
                                                <span className='astuces_promo'><i className='fa fa-bullhorn'></i>Sans offres</span>
                                            </div>
                                    }
                                </div>
                                <div className='astuces'>
                                    <div className='d-flex justify-content-center'>
                                        <span className='astuces_titre'>Réserver en ligne n’a que des avantages</span>
                                    </div>
                                    <div className='astuces_liste'>
                                        <ul>
                                            <li>Le service est accessible à toute heure</li>
                                            <li>Vous recevez une confirmation immédiate par email et SMS</li>
                                            <li>Il est donc inutile d’appeler le restaurant</li>
                                            <li>C’est gratuit !</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9'>
                            <div className='final_resa'>
                                <div className='final_resaHeader'>
                                    <div className='final_resaPropos'>
                                        <h1>Finaliser la réservation au <span>{test.nomRestaurant}</span></h1>
                                        <div><span>Pour le {reservation.date} à {reservation.heure} pour {reservation.personne} personnes</span></div>
                                        {offre.length !== 0 ?
                                            <div><span>{offre.libelle}</span></div>
                                            : ''}

                                    </div>
                                    <div className='final_resaButton'>
                                        <button className='btn' onClick={handleBack}>Modifier la réservation</button>
                                    </div>
                                </div>
                                <div className='final_resaBody'>
                                    <form onSubmit={handleSubmit}>
                                        <div className="final_form">
                                            <div>
                                                <div className="mb-2">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Nom</label>
                                                    <input type="text" className="form-control" value={nom} onChange={(e) => setNom(e.target.value)} id="exampleFormControlInput1" required placeholder="Nom ..." />
                                                </div>
                                                <div className="mb-2">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Prénom</label>
                                                    <input type="text" className="form-control" value={prenom} onChange={(e) => setPrenom(e.target.value)} id="exampleFormControlInput1" required placeholder="Prénom ..." />
                                                </div>
                                                <div className="mb-2">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Adresse email</label>
                                                    <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} id="exampleFormControlInput1" required placeholder="Adresse email ..." />
                                                </div>
                                                <div className="mb-2">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Téléphone</label>
                                                    <input type="text" className="form-control" value={telephone} onChange={(e) => setTelephone(e.target.value)} id="exampleFormControlInput1" required placeholder="Téléphone ..." />
                                                </div>
                                                <div className="mb-2">
                                                    <label htmlFor="exampleFormControlTextarea1" className="form-label">Demande specifique</label>
                                                    <textarea className="form-control" value={demande} onChange={(e) => setDemande(e.target.value)} id="exampleFormControlTextarea1" rows={3} placeholder="Demande specifique ..." />
                                                </div>
                                                <div className='instruction'>
                                                    <h2>Demande à l’attention du restaurant (facultatif)</h2>
                                                    <p>Votre demande sera transmise au restaurant, mais nous ne pouvons vous garantir qu’il pourra satisfaire votre demande</p>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" defaultValue id="flexCheckDefault" />
                                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                                        Je souhaite recevoir des informations de la part de ce restaurant
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" defaultValue required id="flexCheckChecked" defaultChecked />
                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                        Je reconnais avoir pris connaissance et accepter les conditions générales d’utilisation du site xxx
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='final_bodyButton'>
                                                <div className='d-flex justify-content-center'>
                                                    <button type='submit' className='btn'>Términer la réservation</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <p className="version">Version 1</p>
                    </div>
                </div>
               
            </div>
        </div>
    )
}

export default FinalReservation